var $d34552a7550967e7$exports = {};
$d34552a7550967e7$exports = {
  "rangeOverflow": function rangeOverflow(args) {
    return "\uAC12\uC740 ".concat(args.maxValue, " \uC774\uC804\uC774\uC5B4\uC57C \uD569\uB2C8\uB2E4.");
  },
  "rangeReversed": "\uC2DC\uC791\uC77C\uC740 \uC885\uB8CC\uC77C \uC774\uC804\uC774\uC5B4\uC57C \uD569\uB2C8\uB2E4.",
  "rangeUnderflow": function rangeUnderflow(args) {
    return "\uAC12\uC740 ".concat(args.minValue, " \uC774\uC0C1\uC774\uC5B4\uC57C \uD569\uB2C8\uB2E4.");
  },
  "unavailableDate": "\uC120\uD0DD\uD55C \uB0A0\uC9DC\uB97C \uC0AC\uC6A9\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4."
};
export { $d34552a7550967e7$exports as default };